export { TechDetailsForm } from './tech-details-form';
export { technicalDetailsI18n } from './tech-details-from.i18';